import { disablePageScroll, enableScroll } from '../utils/scroll';

export default () => {
  const documents = document.querySelectorAll('.documents');

  documents.forEach((block) => {
    const item = block.querySelectorAll('.documents__item');
    const overlay = block.querySelector('.documents__overlay');
    const btn = block.querySelector('.documents__btn');
    const itemImage = block.querySelectorAll('.documents__item img');
    const fullImage = block.querySelector('.documents__item-full img');

    for (let i = 0; i < item.length; i++) {
      item[i].addEventListener('click', function(event) {
        event.preventDefault();
        let attribute = itemImage[i].getAttribute('src');
        fullImage.setAttribute('src', attribute);
        overlay.classList.add('visible');
        disablePageScroll(true);
      });

      [btn, overlay].forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          overlay.classList.remove('visible');
          enableScroll();
        });
      });

      fullImage.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  });
};


